<template>
  <div>
    <breadcrumbs :home="title"/>

    <v-card flat :loading="loading">
      <v-form v-model="valid" ref="form">
        <v-container class="pt-6 px-6 purtrak-scrollable" fluid>
          <v-row dense>
            <v-col cols="12" sm="6" md="4">
              <v-text-field label="Name" v-model="value.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]" :counter="50" outlined dense/>
            </v-col>
            <v-col cols="2">
              <v-checkbox label="Active" v-model="value.active" dense class="mt-1"/>
            </v-col>
          </v-row>
          <v-row v-if="sites && sites.length>1" dense>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete v-model="value.siteId" outlined dense label="Site"
                              :items="sites" item-text="name" item-value="id"/>
            </v-col>
          </v-row>

          <slot/>

          <v-row dense>
            <v-col>
              <v-btn icon small class="mt-n1" @click="showManufacturer=!showManufacturer"><v-icon>{{showManufacturer?'mdi-menu-up':'mdi-menu-down'}}</v-icon></v-btn>Manufacturer
            </v-col>
          </v-row>
          <v-slide-y-transition>
            <v-row dense v-show="showManufacturer" class="ml-4">
              <v-col cols="12" sm="6" md="4"><v-text-field v-model="value.manufacturer" label="Manufacturer" :rules="[fieldRules.maxLength(50)]" :counter="50" outlined dense/></v-col>
              <v-col cols="6" sm="3" md="2"><v-text-field v-model="value.modelNumber" label="Model #" :rules="[fieldRules.maxLength(20)]" :counter="20" outlined dense/></v-col>
              <v-col cols="6" sm="3" md="2"><v-text-field v-model="value.serialNumber" label="Serial #" :rules="[fieldRules.maxLength(20)]" :counter="20" outlined dense/></v-col>
            </v-row>
          </v-slide-y-transition>

          <v-row dense class="mt-4">
            <v-col>
              <v-btn icon small class="mt-n1" @click="showMaintenance=!showMaintenance"><v-icon>{{showMaintenance?'mdi-menu-up':'mdi-menu-down'}}</v-icon></v-btn>Maintenance
            </v-col>
          </v-row>
          <v-slide-y-transition>
            <v-row dense v-show="showMaintenance" class="ml-4">
              <v-col cols="12" sm="6">
                <outlined-block>
                  <v-container>
                    <v-row dense>
                      <v-col cols="6" md="3"><decimal-number-input v-model="value.maintenance.frequency" integer label="Every" :precision="0" prefix=""/></v-col>
                      <v-col cols="6" md="4"><v-select v-model="value.maintenance.frequencyUnits" :items="['never','days','weeks','months','years']" dense outlined/></v-col>
                      <v-col cols="8" sm="6" md="5"><date-picker v-model="value.maintenance.nextDate" label="Next" date-only :disabled="value.maintenance.frequencyUnits==='never'"/></v-col>
                    </v-row>
                    <v-row dense>
                      <v-col><v-textarea label="Description" v-model="value.maintenance.description" rows="3" outlined :counter="1000"/></v-col>
                    </v-row>
                  </v-container>
                </outlined-block>
              </v-col>
            </v-row>
          </v-slide-y-transition>
        </v-container>
      </v-form>

      <v-divider/>
      <v-card-actions class="px-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="$router.back()">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'EquipmentEdit',
  props: {
    value: {type:Object, required:true},
    title: {type:String, required:true},
    sites: {type:Array, required:false},
    loading: {type:Boolean, required:false, default: false},
    saving: {type:Boolean, required:false, default: false},
    dirty: {type: Boolean, required:false, default: false}
  },
  data () {
    return {
      valid: true,
      showManufacturer: false,
      showMaintenance: false
    }
  },
  watch: {
    value: {
      handler() {this.$emit('update:dirty', true)},
      immediate: true,
      deep: true
    }
  },
  mounted() {
    setTimeout(() => this.$refs.form.validate());
  },
  methods: {
    async save() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.$emit('save', this.value);
    }
  }
}
</script>